import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Divider, Alert } from "antd";
import { UserOutlined, LockOutlined, GoogleOutlined } from "@ant-design/icons";
import useAuthStore from "../../stores/authStore";
import Logo from "../common/Logo"; // added import

const LoginModal = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalWidth, setModalWidth] = useState(420);
  const { isLoginModalVisible, hideLoginModal, login, switchToRegister } =
    useAuthStore();
  const [form] = Form.useForm();

  // Add responsive width adjustment
  useEffect(() => {
    const handleResize = () => {
      // Make the modal narrower on mobile devices
      setModalWidth(window.innerWidth < 480 ? '95%' : 420);
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Initialize width
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleGoogleLogin = () => {
    const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const callBackURI = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
    window.location.replace(
      `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${callBackURI}&prompt=consent&response_type=code&client_id=${clientID}&scope=openid%20email%20profile&access_type=offline`
    );
  };

  const handleCancel = () => {
    setError(null); // Clear errors when modal is closed
    hideLoginModal();
  };

  const onFinish = async (values) => {
    setError(null); // Clear previous errors
    setLoading(true);
    const result = await login(values);
    if (result.success) {
      form.resetFields();
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <Modal
      title={
        <>
          <div style={{ padding: "24px 0 0" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 24,
              }}
            >
              <Logo.Image size={164} hyperlink={true} />{" "}
            </div>
            <h2 style={{ textAlign: "center", marginBottom: 0 }}>
              Login to {Logo.APP_NAME}
            </h2>
          </div>
        </>
      }
      width={modalWidth}
      open={isLoginModalVisible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      bodyStyle={{ padding: "32px 35px 42px" }}
      centered={true} // Add this to center the modal vertically
      styles={{
        header: {
          background: 'transparent',
          borderBottom: 'none'
        },
        content: {
          background: 'linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 1.0)), url("https://upload.wikimedia.org/wikipedia/commons/1/16/Bormio_da_Villa_Feleit_-_panoramio.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '8px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)'
        },
        body: {
          padding: window.innerWidth < 480 ? "24px 20px 32px" : "32px 35px 42px" // Responsive padding
        }
      }}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <Form form={form} name="login" onFinish={onFinish}>
        <Form.Item
          name="email"
          rules={[{ required: true, message: "Please input your email!" }]}
        >
          <Input prefix={<UserOutlined />} placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="Password" />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%" }}
            loading={loading}
          >
            Log in
          </Button>
        </Form.Item>
      </Form>

      <Divider>Or</Divider>

      <Button
        icon={<GoogleOutlined />}
        onClick={handleGoogleLogin}
        style={{ width: "100%" }}
        disabled={loading}
      >
        Login with Google
      </Button>
      <div style={{ textAlign: "center", marginTop: 16 }}>
        Don't have an account?{" "}
        <Button type="link" onClick={switchToRegister} style={{ padding: 0 }}>
          Register now
        </Button>
      </div>
    </Modal>
  );
};

export default LoginModal;
